module.exports = __webpack_public_path__ + "static/media/images-removebg-preview.474e999b.png";